export default "__VITE_ASSET__VJxFIYPu__"